import border from '../../border';

const primary = (params) => border.disabled.primary(params);

export default primary;
